import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {IssueDTO} from "../domain/dtos/issue.dto";
import {Issue} from "../domain/entities/issue.entity";
import {TransformerInterface} from "./transformerInterface";

@injectable()
@transformer({
    source: Issue,
    target: `dto`
})
export class IssueToIssueDtoTransformer implements TransformerInterface<Partial<IssueDTO>, Issue> {

    transform(issue: Issue): Promise<Partial<IssueDTO>> {

        let dto = <Partial<IssueDTO>>{
            uid: issue.uid,
            title: issue.title,
            type: issue.type.uid,
            start: issue.start.toSQL(),
            end: issue.end.toSQL(),
            status: issue.status?.uid ?? null,
            employees: issue.employees.map(employee => employee.uid),
            description: issue.description,
            project: issue.project?.uid ?? null,
            creator: issue.creator?.uid ?? null,
            keywords: issue.keywords.map(keyword => keyword.uid)
        };

        if (!issue.isNew()) {
            let changedValues = issue.changedValues;
            const indexOfTimeRange = changedValues.indexOf(`timeRange`);
            if (indexOfTimeRange > -1) {
                changedValues = [...changedValues.slice(0, indexOfTimeRange), `start`, `end`, ...changedValues.slice(indexOfTimeRange + 1)];
            }
            const keyValuePairs = new Map<string, any>(Object.entries(dto));

            for (const key of keyValuePairs.keys()) {
                if (!changedValues.includes(key as keyof Issue) && key !== `uid`) {
                    keyValuePairs.delete(key);
                }
            }
            dto = Object.fromEntries(keyValuePairs);
        }

        return Promise.resolve(dto);
    }

}